import {http} from "../_helpers";

class LocationService {
    getAllCities() {
        return http.get(`/locations/cities`)
    }
}

export default new LocationService;
